/* eslint-disable camelcase */

class Checkpoint {
	constructor({
		id,
		organizer,
		status,
		name,
		color,
		default_nb_access,
		barcode_type,
		identification_types,
		modified,
		pairing_mode,
		cashless_access_counter_id,
		cashless_access_period_id,
		alternative_checkpoints,
		allowed_partners,
		show_counter,
		removed,
		modified_in_butter,
		allow_merging,
		weez_id
	}) {
		this._id = id;
		this._organizer = organizer;
		this._status = status;
		this._name = name;
		this._color = color;
		this._default_nb_access = default_nb_access;
		this._barcode_type = barcode_type;
		this._identification_types = identification_types;
		this._modified = modified;
		this._pairing_mode = pairing_mode;
		this._cashless_access_counter_id = cashless_access_counter_id;
		this._cashless_access_period_id = cashless_access_period_id;
		this._alternative_checkpoints = alternative_checkpoints;
		this._allowed_partners = allowed_partners;
		this._show_counter = show_counter;
		this._removed = removed;
		this._modified_in_butter = modified_in_butter;
		this._allow_merging = allow_merging;
		this._weez_id = weez_id;
	}

	getId() {
		return this._id;
	}

	getKey() {
		return String(this._id);
	}

	getOrganizer() {
		return this._organizer;
	}

	getStatus() {
		return this._status;
	}

	getName() {
		return this._name;
	}

	getColor() {
		return this._color;
	}

	getDefaultNbAccess() {
		return this._default_nb_access;
	}

	getBarcodeType() {
		return this._barcode_type;
	}

	getIdentificationTypes() {
		return this._identification_types;
	}

	getModified() {
		return this._modified;
	}

	getPairingMode() {
		return this._pairing_mode;
	}

	getCashlessAccessCounterId() {
		return this._cashless_access_counter_id;
	}

	getCashlessAccessPeriodId() {
		return this._cashless_access_period_id;
	}

	getAlternativeCheckpoints() {
		return this._alternative_checkpoints;
	}

	getAllowedPartners() {
		return this._allowed_partners;
	}

	getShowCounter() {
		return this._show_counter;
	}

	getRemoved() {
		return this._removed;
	}

	getModifiedInButter() {
		return this._modified_in_butter;
	}

	getAllowMerging() {
		return this._allow_merging;
	}

	getWeezId() {
		return this._weez_id;
	}

	toString() {
		return this._name;
	}
}

export default Checkpoint;
